import { Tabs } from '@mui/material';
import React, {
  FC,
  PropsWithChildren,
  SyntheticEvent,
  useCallback,
} from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AdminTabValue } from './types';
import { generateUrlWithCompany } from 'src/helpers/helpers';
import { LinkTab } from 'src/components/LinkTab';
import { useSelector } from 'react-redux';
import { getCurrentCompanyId } from 'src/modules/companies/slices';

type AdminTabsProps = {
  value: AdminTabValue;
};

const AdminTabs: FC<PropsWithChildren<AdminTabsProps>> = (props) => {
  const { value } = props;
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const urlCompanyId = searchParams.get('companyId');
  const currentCompanyId = urlCompanyId || localStorage.getItem('bhiCurrentCompany') || useSelector(getCurrentCompanyId);

  const paths = {
    companies: '/admin/companies',
    signups: '/admin/signups',
    plans: '/admin/plans',
    applications: '/admin/applications',
    campaigns: '/admin/campaigns',
    configCategories: '/admin/config-categories',
    blocklist: '/admin/blocklist',
    reports: '/admin/reports',
  };

  const handleTabChange = useCallback((_: SyntheticEvent, value: AdminTabValue) => {
    switch (value) {
      case "companies":
        return navigate(paths.companies);

      case "signups":
        return navigate(paths.signups);

      case "plans":
        return navigate(paths.plans);

      case "applications":
        return navigate(paths.applications);

      case "campaigns":
        return navigate(paths.campaigns);

      case "configCategories":
        return navigate(paths.configCategories);

      case "blocklist":
        return navigate(paths.blocklist);

      case "reports":
        return navigate(paths.reports);
    }
  }, []);

  return (
    <Tabs
      value={value}
      onChange={handleTabChange}
      aria-label="admin tabs"
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
    >
      <LinkTab label="Companies" value="companies" key="companies" to={generateUrlWithCompany(paths.companies, currentCompanyId)} />
      <LinkTab label="Plans" value="plans" key="plans" to={generateUrlWithCompany(paths.plans, currentCompanyId)} />
      <LinkTab label="Applications" value="applications" key="applications" to={generateUrlWithCompany(paths.applications, currentCompanyId)} />
      <LinkTab label="Campaigns" value="campaigns" key="campaigns" to={generateUrlWithCompany(paths.campaigns, currentCompanyId)} />
      <LinkTab label="Campaign Categories" value="configCategories" key="configCategories" to={generateUrlWithCompany(paths.configCategories, currentCompanyId)} />
      <LinkTab label="Blocklist" value="blocklist" key="blocklist" to={generateUrlWithCompany(paths.blocklist, currentCompanyId)} />
      <LinkTab label="Telnyx Errors" value="reports" key="reports" to={generateUrlWithCompany(paths.reports, currentCompanyId)} />
      <LinkTab label="Signups" value="signups" key="signups" to={generateUrlWithCompany(paths.signups, currentCompanyId)} />
    </Tabs>
  );
};

export default AdminTabs;
